<template>
  <div>
    
    <el-dialog
      title="로그인"
      :visible.sync="open"
      custom-class="login-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
      <template slot="title">
        <img class="logo-image" src="../assets/logo.png">
      </template>
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="ID">
          <el-input v-model="form.username" @keyup.enter.native="loginHandler"></el-input>
        </el-form-item>
        <el-form-item label="Password">
          <el-input v-model="form.password" type="password" @keyup.enter.native="loginHandler"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="loginHandler">로그인</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  methods: {
    async loginHandler () {
      // if (!this.form.username || !this.form.password) return;
      if (!this.form.username) {
        this.$service.$emit('alert-modal', '아이디를 입력해주세요')
        return
      }else if (!this.form.password) {
        this.$service.$emit('alert-modal', '패스워드를 입력해주세요')
        return
      }
      
      this.loading = true
      try {
        let response = await this.$http.post('auth', this.form)
        this.$service.setAccessToken(response.data.access_token)
        response = this.$service.getUserInfo()
        
        let next = this.$route.query.r || 'dashboard'
        this.$router.push({name: next})
        this.$service.$emit('alert-modal', '시스템관리자로 로그인 되었습니다')
            
        this.loading = false
        return response
      }
      catch(err) {
        if (err.response) {
          switch (err.response.status) {
            case 401:
              this.$service.$emit('alert-modal', '아이디 또는 비밀번호가 맞지 않습니다.')
              break;
            default:
              this.$service.$emit('alert-modal', 'API 서버에 접속 할 수 없습니다.')
              break;
          }
        }
        else {
          console.log('UNHANDLED ERROR')
          console.log(err)
        }
        
        this.loading = false
        return false
        // throw Error(err)
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.open = true
    }, 1000)
  },
  data () {
    return {
      open: false,
      loading: false,
      form: {
        username: '',
        password: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.logo-image {
  display: block;
  margin: 0 auto;
}
/deep/ .login-dialog {
  width: 50%;
  min-width: 400px;
  max-width: 650px;
  @media screen and (max-width: 768px) {
    width: calc(100% - 20px);
  }
}
</style>


